"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FilePdfIcon = function FilePdfIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    role: "img",
    "aria-label": "PDF file icon",
    viewBox: "0 0 256 256"
  }, props), _react.default.createElement("path", {
    d: "M220 256H36c-19.85 0-36-16.15-36-36V36C0 16.15 16.15 0 36 0h184c19.85 0 36 16.15 36 36v184c0 19.85-16.15 36-36 36zM36 24c-6.62 0-12 5.38-12 12v184c0 6.62 5.38 12 12 12h184c6.62 0 12-5.38 12-12V36c0-6.62-5.38-12-12-12H36z"
  }), _react.default.createElement("path", {
    d: "M58.14 219.98c-8.98 0-16.21-5.49-19.44-12.43-2.59-4.85-7.02-17.74 7.76-32.85 5.68-5.8 15.93-16.28 41.59-25.32 3.04-6.18 6.3-13.1 9.76-20.82 3.66-8.17 6.67-15.19 9.14-21.26-9.65-16.62-11.77-29.69-11.41-44.64C96.01 43.08 109.61 36 118.68 36h.07l.76.03c.87.06 21.25 1.75 22.35 30.19.35 9.02-1.12 19.3-8.09 38.31 4.82 6.78 11.22 14.62 19.71 23.95 2.49 2.74 4.8 5.25 6.95 7.56 20.68-.61 37.26 2.37 47.69 8.86 6.98 4.34 11.17 10.89 11.8 18.46.42 4.95-.84 8.85-1.42 10.33-2.62 6.91-12.57 18.22-32.21 12.97-10.2-2.73-17.49-7.12-35.68-26.04-7.48.67-16.06 1.87-25.88 3.8-7.47 1.47-14.02 3.06-19.77 4.73-21.91 42.3-32.99 47.01-37.1 48.76-3.38 1.43-6.65 2.07-9.72 2.07zm138.04-54.12zm-72.89-35.56c-1.13 2.58-2.32 5.27-3.58 8.08-.43.95-.85 1.89-1.27 2.82.55-.11 1.1-.22 1.66-.33 3.58-.7 7.11-1.33 10.56-1.88-2.64-3.02-5.09-5.91-7.37-8.69z"
  }));
};

FilePdfIcon.displayName = 'FilePdfIcon';
FilePdfIcon.propTypes = {
  color: _propTypes.string,
  size: _propTypes.number
};
FilePdfIcon.defaultProps = {
  color: _colors.default.iconColor,
  size: 40
};
var _default = FilePdfIcon;
exports.default = _default;